/**
 * Marks a value written by `encrypt`, so `decrypt` can tell it apart from plain values and from values
 * that an older format wrote, which it cannot read.
 */
export const CIPHER_PREFIX = 'aes-gcm:';
export const IV_LENGTH = 12;
